/*  libs */
import React, { Component } from "react";
import { Route, Redirect, withRouter, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import axios from "axios";
import { isEmpty } from "lodash";

/* pages */
import Nav from "../nav/Nav";
import DashboardPage from "../pages/DashboardPage";
import DevPage from "../pages/DevPage";
import Logout from "../pages/LogoutPage";
import PagesPage from "../pages/PagesPage/";
import ThemesPage from "../pages/ThemesPage/";
import ExperiencesPage from "../pages/ExperiencesPage/";
import NotificationsPage from "../pages/NotificationsPage/";
import TopicsPage from "../pages/TopicsPage";
import PostsPage from "../pages/PostsPage";
import SessionsPage from "../pages/SessionsPage";
import QAManagerPage from "../pages/QAManagerPage";
import UsersPage from "../pages/UsersPage";
import AppConfigPage from "../pages/AppConfig";
import EditAppForm from "../pages/AppsPage/EditAppForm";
import Integrations from "../pages/Integrations";
import AppNavigation from "../pages/AppNavigation";
import ExperienceNavigation from "../pages/ExperienceNavigation";
import OnBoarding from "../pages/OnBoarding";
import AppsPage from "../pages/AppsPage";
import TermsPage from "../pages/Terms";
import PrivacyPage from "../pages/Privacy";
import RedirectPage from "../pages/Redirect";
import ChatManagerPage from "../pages/ChatManagerPage/index.jsx";
import AccessDenied from "./AccessDenied";
import * as appConfigActions from "../../actions/appConfigActions";
import * as controlPanelActions from "../../actions/controlPanelActions";
import * as responsiveActions from "../../actions/responsiveActions";
import * as userActions from "../../actions/userActions";
import * as appsActions from "../../actions/appsActions";
import * as modulesActions from "../../actions/modulesActions";
import * as constants from "../../constants";
import UserHasPermission from "../../helpers/validation/userHasPermission";
import UserIsGlobal from "../../helpers/validation/userIsGlobal";
import parseAppKey from "../../helpers/routeHelpers/parseAppKey";
import PollingResults from "../pages/PollingResults";

class LoggedInContent extends Component {
	constructor(props) {
		super(props);
		let showContent = true;
		var activateUser = localStorage.getItem("activateUser");
		var newUser = localStorage.getItem("newUser");
		if (activateUser && props.user) {
			if (!newUser || newUser.length === 0) {
				showContent = false;
			}
		}
		this.state = {
			showContent,
		};
		this.meFetch = null;
	}

	componentDidMount() {
		const {
			appConfig: { appConfig },
			appConfigActions,
		} = this.props;
		const appKey = parseAppKey();

		if (appKey && isEmpty(appConfig)) {
			appConfigActions.loadAppConfig(appKey);
		}

		var activateUser = localStorage.getItem("activateUser");
		var newUser = localStorage.getItem("newUser");
		if (activateUser && this.props.user) {
			if (!newUser || newUser.length === 0) {
				localStorage.removeItem("activateUser");
				const payload = Object.assign({}, JSON.parse(activateUser), { firebaseUserId: this.props.user.uid });
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
				});
				this.props.controlPanelActions.showLoading();
				api.post(`/users/${payload.id}/activate`, payload)
					.then(() => {
						setTimeout(() => {
							window.location.reload();
						}, 500);
					})
					.catch(() => {
						// TODO logsee this
						this.props.controlPanelActions.hideLoading();
						alert("Something went wrong while activating your account.");
					});
			}
		}
		this.props.appsActions.loadApps();
		this.props.modulesActions.loadModules();
		this.meFetch = setInterval(this.fetchMe, 60000);
	}

	componentDidUpdate() {
		const {
			appConfig: { appConfig, appName },
			appConfigActions,
		} = this.props;
		const appKey = parseAppKey();

		if (!appKey && !isEmpty(appConfig)) {
			// if we go back to the /apps route, we clear the existing config from state
			appConfigActions.clearAppConfig();
		} else if (appKey && appKey !== appName && appKey !== "add") {
			// if we switch apps, we reload the app config
			appConfigActions.loadAppConfig(appKey);
		}
	}

	componentWillUnmount() {
		clearInterval(this.meFetch);
	}

	fetchMe = () => {
		this.props.userActions.getUser();
	};

	render() {
		const {
			verrisUser,
			location,
			responsive: { displaySideMenu, isResponsive },
		} = this.props;
		let experienceNavigation = AccessDenied;
		let pagesPage = AccessDenied;
		let themesPage = AccessDenied;
		let experiencesPage = AccessDenied;
		let notificationsPage = AccessDenied;
		let topicsPage = AccessDenied;
		let postsPage = AccessDenied;
		let sessionsPage = AccessDenied;
		let qaPage = AccessDenied;
		let usersPage = AccessDenied;
		let editAppForm = AccessDenied;
		let integrations = AccessDenied;
		let appNavigation = AccessDenied;
		let appConfig = AccessDenied;
		let chatManagerPage = AccessDenied;

		let newAppView = AccessDenied;
		if (verrisUser && verrisUser.globalRole === "master") {
			newAppView = OnBoarding;
		}

		if (verrisUser) {
			if (UserHasPermission(verrisUser, "content")) {
				pagesPage = PagesPage;
				postsPage = PostsPage;
				sessionsPage = SessionsPage;
				notificationsPage = NotificationsPage;
				chatManagerPage = ChatManagerPage;
			}
			if (UserHasPermission(verrisUser, "structure")) {
				experienceNavigation = ExperienceNavigation;
				themesPage = ThemesPage;
			}
			if (UserHasPermission(verrisUser, "full")) {
				integrations = Integrations;
				topicsPage = TopicsPage;
				appNavigation = AppNavigation;
				editAppForm = EditAppForm;
				usersPage = UsersPage;
				experiencesPage = ExperiencesPage;
				qaPage = QAManagerPage;
			}
			if (UserIsGlobal(verrisUser)) {
				appConfig = AppConfigPage;
			}
		}

		const fullPagePaths = ["/apps/add", "/apps", "/terms", "/privacy"];

		// console.log('are we showing the sideMenu?', this.props.responsive.displaySideMenu)

		return (
			<div>
				{this.state.showContent && verrisUser && (
					<div className={isResponsive && displaySideMenu ? "sidebar-open" : ""}>
						<Switch>
							<Route path="/apps/add" exact render={() => null} />
							<Route path="/apps" exact render={() => null} />
							<Route path="/terms" exact render={() => null} />
							<Route path="/privacy" exact render={() => null} />
							<Route path="/apps/:appKey/experiences/:expId/pages/new" component={Nav} />
							<Route path="/apps/:appKey/experiences/:expId/pages/copy" component={Nav} />
							<Route path="/apps/:appKey/experiences/:expId/pages/:pageId" component={Nav} />
							<Route path="/apps/:appKey/experiences/new" component={Nav} />
							<Route path="/apps/:appKey/experiences/copy" component={Nav} />
							<Route path="/apps/:appKey/experiences/:expId" component={Nav} />
							<Route path="/apps/:appKey/themes/:themeId" component={Nav} />
							<Route path="/apps/:appKey" component={Nav} />
							<Route path="/dev" component={Nav} />
							<Route path="/" render={props => <Nav {...props} sideNavHidden />} />
						</Switch>
						<div className={fullPagePaths.includes(location.pathname) ? "" : "content-wrapper"}>
							<Route exact path="/" render={() => <Redirect to={"/apps"} />} />
							<Switch>
								<Route path="/dashboard" component={DashboardPage} />
								<Route path="/dev" component={DevPage} />
								<Route path="/logout" component={Logout} />
								<Route path="/terms" exact component={TermsPage} />
								<Route path="/privacy" exact component={PrivacyPage} />
								<Route path="/redirect" exact component={RedirectPage} />
								<Route path="/apps/add" exact component={newAppView} />
								<Route path="/apps" exact render={props => <AppsPage {...props} />} />
								<Route path="/create" exact component={newAppView} />
								<Route path="/apps/:appKey/experiences/:expId/pages" component={pagesPage} />
								<Route
									path="/apps/:appKey/experiences/:expId/navigation"
									component={experienceNavigation}
								/>
								<Route
									path="/apps/:appKey/experiences/:expId/chat/:chatId"
									component={chatManagerPage}
								/>
								<Route
									path="/apps/:appKey/experiences/:expId/polls/:pageId"
									component={PollingResults}
								/>
								<Route path="/apps/:appKey/experiences" component={experiencesPage} />
								<Route path="/apps/:appKey/navigation" component={appNavigation} />
								<Route path="/apps/:appKey/users" component={usersPage} />
								<Route path="/apps/:appKey/notifications" component={notificationsPage} />
								<Route path="/apps/:appKey/topics" component={topicsPage} />
								<Route path="/apps/:appKey/themes" component={themesPage} />
								<Route path="/apps/:appKey/Posts" component={postsPage} />
								<Route path="/apps/:appKey/sessions" component={sessionsPage} />
								<Route path="/apps/:appKey/qa" component={qaPage} />
								<Route path="/apps/:appKey/integrations" component={integrations} />
								<Route path="/apps/:appKey/settings" component={editAppForm} />
								<Route path="/apps/:appKey/config" component={appConfig} />
								<Route path="/apps/:appKey" component={DashboardPage} />
							</Switch>
						</div>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	appConfig: state.appConfig,
	apps: state.apps,
	responsive: state.responsive,
	user: state.auth.user,
	verrisUser: state.user.user,
});

const mapDispatchToProps = dispatch => ({
	appConfigActions: bindActionCreators(appConfigActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
	responsiveActions: bindActionCreators(responsiveActions, dispatch),
	userActions: bindActionCreators(userActions, dispatch),
	appsActions: bindActionCreators(appsActions, dispatch),
	modulesActions: bindActionCreators(modulesActions, dispatch),
});

LoggedInContent.propTypes = {
	appConfig: PropTypes.object,
	appConfigActions: PropTypes.object,
	apps: PropTypes.object,
	appsActions: PropTypes.object,
	controlPanelActions: PropTypes.object,
	experiences: PropTypes.object,
	location: PropTypes.object,
	modulesActions: PropTypes.object,
	responsive: PropTypes.object,
	responsiveActions: PropTypes.object,
	user: PropTypes.object,
	userActions: PropTypes.object,
	verrisUser: PropTypes.object,
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(LoggedInContent)
);
